export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/account-icon.svg?c65a55ed065c4c7aeff32a310e999062";